import { createAction, props } from '@ngrx/store';
import {ItemType} from '@emm/core/models/item-type.model';
import {SearchFilter} from '@emm/core/models/search-filter';

export enum ItemTypesAction {
    LoadAll = '[Item Types Management] Load All Item Types',
    LoadAllSuccess = '[Management API] Load All Item Types Success',
    LoadAllFailure = '[Management API] Load All Item Types Failure',
    Select = '[Item Types Management] Select Item Type',
    SearchItemTypes = '[Item Types Management] Search Item Types',
    LoadAllForItems = '[Items Management] Load All Item Types For Items',
    LoadAllForItemsSuccess = '[Management API] Load All Item Types For Items Success',
    LoadAllForItemsFailure = '[Management API] Load All Item Types For Items Failure',
    LoadAllForItemGroups = '[Item Groupings Management] Load All Item Types For Item Groups',
    LoadAllForItemGroupsSuccess = '[Management API] Load All Item Types For Item Groups Success',
    LoadAllForItemGroupsFailure = '[Management API] Load All Item Types For Item Groups Failure',
    OpenAddDialog = '[Item Types Management] Open Add Item Type Dialog',
    Delete = '[Item Types Management] Delete Item Type',
    DeleteSuccess = '[Management API] Delete Item Type Success',
    DeleteFailure = '[Management API] Delete Item Type Failure'
}

export const ItemTypesActions = {
    loadAll: createAction(ItemTypesAction.LoadAll),
    loadAllSuccess: createAction(ItemTypesAction.LoadAllSuccess, props<{ itemTypes: ItemType[] }>()),
    loadAllFailure: createAction(ItemTypesAction.LoadAllFailure, props<{ error: any }>()),
    select: createAction(ItemTypesAction.Select, props<{ tag: string }>()),
    searchItemTypes: createAction(ItemTypesAction.SearchItemTypes, props<{ filter: SearchFilter }>()),
    loadAllForItems: createAction(ItemTypesAction.LoadAllForItems),
    loadAllForItemsSuccess: createAction(
        ItemTypesAction.LoadAllForItemsSuccess,
        props<{ itemTypes: ItemType[] }>()
    ),
    loadAllForItemsFailure: createAction(ItemTypesAction.LoadAllForItemsFailure, props<{ error: any }>()),
    loadAllForItemGroups: createAction(ItemTypesAction.LoadAllForItemGroups),
    loadAllForItemGroupsSuccess: createAction(
        ItemTypesAction.LoadAllForItemGroupsSuccess,
        props<{ itemTypes: ItemType[] }>()
    ),
    loadAllForItemGroupsFailure: createAction(
        ItemTypesAction.LoadAllForItemGroupsFailure,
        props<{ error: any }>()
    ),
    openAddDialog: createAction(ItemTypesAction.OpenAddDialog),
    delete: createAction(ItemTypesAction.Delete, props<{ itemType: ItemType }>()),
    deleteSuccess: createAction(ItemTypesAction.DeleteSuccess),
    deleteFailure: createAction(ItemTypesAction.DeleteFailure, props<{ error: any }>())
};

export const AsyncActions = {
    loadActions: [
        ItemTypesActions.loadAll,
        ItemTypesActions.loadAllForItems,
        ItemTypesActions.loadAllForItemGroups,
        ItemTypesActions.delete
    ],
    successActions: [
        ItemTypesActions.loadAllSuccess,
        ItemTypesActions.loadAllForItemsSuccess,
        ItemTypesActions.loadAllForItemGroupsSuccess,
        ItemTypesActions.deleteSuccess
    ],
    errorActions: [
        ItemTypesActions.loadAllFailure,
        ItemTypesActions.loadAllForItemsFailure,
        ItemTypesActions.loadAllForItemGroupsFailure,
        ItemTypesActions.deleteFailure
    ]
};
